import { SEARCH_PROPERTY_STATUS_ALL_PROPERTIES_VALUE } from '../types';

export const isPropertyStatusAllProperties = (status: string | undefined): boolean =>
  status === SEARCH_PROPERTY_STATUS_ALL_PROPERTIES_VALUE;
